import $ from 'jquery';
import 'jquery.dotdotdot/src/jquery.dotdotdot.js';
import 'bootstrap/js/dist/collapse.js';
import 'bootstrap/js/dist/tab.js';
import './ui/Modal.mjs';
import './ui/VideoHandler.mjs';
import {isIE, isTouchDevice} from './utilities/user-agent.mjs';
import throttle from 'lodash/throttle.js';
import Aside from './ui/Aside.mjs';
import Footer from './ui/Footer.mjs';
import Form from './ui/Form.mjs';
import Header from './ui/Header.mjs';
import OffCanvas from './ui/OffCanvas.mjs';

export default class Ui {
  constructor() {
    this.$window = $(window);
    this.$body = $('body');
    initHelperClasses.call(this);
    this.Header = new Header(this);
    this.Footer = new Footer();
    this.Form = new Form(this);
    this.OffCanvas = OffCanvas;
    this.Aside = Aside;

    initToTopButton.call(this);
    initTrippleDots.call(this);
  }
}

/**
 * Copy from ui/ui.js
 */
function initHelperClasses() {
  if (isIE) {
    this.$body.addClass('is-IE');
  }

  this.$body.addClass(() => {
    return isTouchDevice ? 'isTouch' : 'noTouch';
  });
}

/**
 * Copy from ui/ui.js
 */
function initToTopButton() {
  const $button = $('#btn-to-top');
  let lastPixelScrolled = 0;

  this.$window.on('scroll.Ui.toTopButton', throttle(
    () => {
      const pixelScrolled = this.$window.scrollTop();
      if (pixelScrolled <= lastPixelScrolled) {
        $button.show();
      } else {
        $button.hide();
      }
      lastPixelScrolled = pixelScrolled;
    },
    125,
  ));

  $button.on('click', function() {
    $('html, body').animate({
      scrollTop: 0,
    }, 1000);
    return false;
  });
}

/**
 * Copy from ui/ui.js->trippleDots()
 */
function initTrippleDots() {
  $('.teaser-highlight-product-copytext').dotdotdot({
    ellipsis: ' ...',
    watch: true,
  });
}
